import React from 'react';

const DialogFooter = ({ children, ...props }) => (
	<footer className="modal-card-foot" {...props}>
		{children}
	</footer>
);

export default DialogFooter;
